<template>
  <div class="cml-input-maxlength">
    <el-divider class="cml-divider" id="cml-divider" content-position="center"
      >{{ statusName }}单个原料样品</el-divider
    >
    <el-form
      :disabled="formDisabled"
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="300px"
    >
      <el-form-item label="供应商" prop="supplierName">
        <el-input v-if="!['2', '1'].includes(this.$store.getters.userSelf.user.adminType) || status !== 'add'" disabled v-model.trim="formData.supplierName" />
        <SupplierSelect
          v-else
          :disabled="
            !['2', '1'].includes(this.$store.getters.userSelf.user.adminType) ||
            status !== 'add'
          "
          supplierType="RAW_MATERIAL"
          :value="formData.supplierCode"
          @change-emit="supplierChange"
        />
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input
          v-model.trim="formData.productName"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="中文INCI名称" prop="chineseInciName">
        <el-input
          style="width: 420px"
          type="textarea"
          v-model="formData.chineseInciName"
          placeholder="多个组分请用逗号隔开"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="英文INCI名称" prop="englishInciName">
        <el-input
          style="width: 420px"
          type="textarea"
          v-model="formData.englishInciName"
          placeholder="多个组分请用逗号隔开"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="CAS#" prop="cas">
        <el-input
          style="width: 420px"
          type="textarea"
          v-model="formData.cas"
          maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="EC#" prop="ec">
        <el-input
          style="width: 420px"
          type="textarea"
          v-model="formData.ec"
          maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="是否为自己生产" prop="whetherSelfProduction">
        <DictSelect
          type="cml_common_whether"
          :value="formData.whetherSelfProduction"
          @change-emit="val => (formData.whetherSelfProduction = val)"
        />
      </el-form-item>
      <el-form-item label="是否进口" prop="whetherImport">
        <DictSelect
          type="cml_common_whether"
          :value="formData.whetherImport"
          @change-emit="whetherImportChange"
        />
      </el-form-item>
      <el-form-item label="是否国内有售卖" prop="whetherInternalSale">
        <DictSelect
          type="cml_common_whether"
          :value="formData.whetherInternalSale"
          @change-emit="val => (formData.whetherInternalSale = val)"
        />
      </el-form-item>
      <el-form-item label="生产厂家" prop="manufacturer">
        <el-input
          style="width: 420px"
          type="textarea"
          v-model="formData.manufacturer"
          maxlength="60"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="formData.whetherImport === 'YES'"
        label="生产产地"
        prop="productionCountryId"
      >
        <CountrySelect
          :value="formData.productionCountryId"
          @change-emit="val => (formData.productionCountryId = val)"
        />
      </el-form-item>
      <el-form-item label="原料分类" prop="rawMaterialCategory">
        <el-checkbox-group
          v-model="formData.rawMaterialCategory"
          style="width: 420px"
          @change="rawMaterialCategoryChange"
        >
          <el-checkbox
            v-for="(item, index) in raw_material_category"
            :key="index"
            :label="item.value"
            name="type"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        v-if="formData.rawMaterialCategory.includes('FUNCTIONAL_RAW_MATERIALS')"
        label="原料功效"
        prop="rawMaterialEfficacy"
      >
        <el-checkbox-group
          v-model="formData.rawMaterialEfficacy"
          style="width: 440px"
        >
          <el-checkbox
            v-for="(item, index) in raw_material_efficacy"
            :key="index"
            :label="item.value"
            name="type"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        v-if="formData.rawMaterialCategory.includes('BASIC_RAW_MATERIALS')"
        label="原料功能"
        prop="rawMaterialFunction"
      >
        <el-checkbox-group
          v-model="formData.rawMaterialFunction"
          style="width: 440px"
        >
          <el-checkbox
            v-for="(item, index) in raw_material_function"
            :key="index"
            :label="item.value"
            name="type"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="外观形态" prop="appearance">
        <el-input
          v-model.trim="formData.appearance"
          placeholder="例如：透明液体(需包含：原料颜色+液体或固体或香精)"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="建议添加量" prop="recommendedAddition">
        <el-input
          v-model.trim="formData.recommendedAddition"
          placeholder="例如：3%—5%"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="最高使用量" prop="maximumUsage">
        ≤
        <CustomNumInput
          ref="customNumInput"
          class="maximumUsage"
          :value="formData.maximumUsage"
          :maxlength="7"
          :limitNum="3"
          :isNegativeFloat="true"
          @change-emit="maximumUsageChange"
        />%
      </el-form-item>
      <el-form-item label="使用说明" prop="instructions">
        <el-input
          style="width: 420px"
          type="textarea"
          v-model="formData.instructions"
          placeholder="例如：本品具有促进皮细胞生成,能使伤口迅速愈合,是皮肤创伤的良好愈合剂，又能软化角质素，使皮肤保持水分，滋润和柔软，本品可用作护肤乳液、洗面奶、唇膏、剃须膏、防晒剂、牙膏等产品的添加剂，也可作为皮肤伤口愈合剂。本品的推荐用量为0.1~0.5%"
          maxlength="300"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="包装规格（kg）" prop="packageSpecification">
        <CustomNumInput
          :value="formData.packageSpecification"
          :maxlength="7"
          :limitNum="3"
          :isNegativeFloat="true"
          @change-emit="val => (formData.packageSpecification = val)"
        />
      </el-form-item>
      <el-form-item label="保质期（月）" prop="qualityPeriod">
        <CustomNumInput
          :value="formData.qualityPeriod"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.qualityPeriod = val)"
        />
      </el-form-item>
      <el-form-item label="储存条件" prop="storageConditions">
        <DictSelect
          type="storage_conditions"
          :value="formData.storageConditions"
          @change-emit="value => (formData.storageConditions = value)"
        />
      </el-form-item>
      <el-form-item label="是否有专利" prop="havePatent">
        <DictSelect
          type="cml_common_whether"
          :value="formData.havePatent"
          @change-emit="value => (formData.havePatent = value)"
        />
      </el-form-item>
      <el-form-item label="预估含税单价（元/kg）" prop="price">
        <CustomNumInput
          :value="formData.price"
          :maxlength="7"
          :isNegativeFloat="true"
          @change-emit="val => (formData.price = val)"
        />
      </el-form-item>
      <el-form-item label="采购周期（天）" prop="purchasingCycle">
        <CustomNumInput
          :value="formData.purchasingCycle"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.purchasingCycle = val)"
        />
      </el-form-item>
      <el-form-item label="正式订单的最低起订量（kg）" prop="minNum">
        <CustomNumInput
          :value="formData.minNum"
          :maxlength="7"
          :limitNum="3"
          :isNegativeFloat="true"
          @change-emit="val => (formData.minNum = val)"
        />
      </el-form-item>
      <el-form-item label="样品的发货时间" prop="deliveryTime">
        <CustomNumInput
          :value="formData.deliveryTime"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.deliveryTime = val)"
        />
        天内
      </el-form-item>
      <el-form-item label="附件">
        <el-row class="fujian-row">
          <el-col :span="8" v-for="(item, index) in uploadBtns" :key="index">
            <UploadFile
              ref="uploadRef"
              :btnName="item.name"
              :multiple="item.multiple"
              :maxSize="100"
              :excelFileExtend="'.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.png,.jpeg'"
              :required="index < 2"
              :disabled="formDisabled"
            />
          </el-col>
        </el-row>
        <div class="fujian-row2">
          <UploadFile
            ref="uploadMultipleRef"
            btnName="厂家介绍等其它文件"
            :multiple="true"
            :maxSize="100"
            :excelFileExtend="'.doc,.docx,.pdf,.wmv,.xls,.xlsx,.ppt,.pptx,.jpg,.png,.jpeg'"
            :disabled="formDisabled"
          />
        </div>
      </el-form-item>
    </el-form>

    <p
      v-if="!formDisabled && status !== 'verify'"
      style="margin: 40px 0 50px 300px"
      id="editor-box"
    >
      <el-button size="medium" :loading="saveLoading" @click="saveBtn"
        >保存草稿</el-button
      >
      <el-button
        type="primary"
        size="medium"
        style="margin-left: 50px"
        :loading="saveLoading"
        @click="submitBtn"
        >提交审核</el-button
      >
    </p>

    <SubmitDialog
      :dialogVisible="dialogVisible"
      @create-again="createAgain"
      @to-sample-page="toSamplePage"
    />

    <!-- 审核 -->
    <VerifyComponent
      ref="verifyComponent"
      :status="status"
      :statusName="statusName"
      :saveLoading="saveLoading"
      @verify-btn="verifyBtn"
    />
  </div>
</template>
<script>
import SupplierSelect from '@/components/SupplierSelect';
import DictSelect from '@/components/DictSelect';
import CustomNumInput from '@/components/CustomNumInput';
import UploadFile from '@/components/Upload/UploadFile.vue';
import CountrySelect from '@/components/CountrySelect';
import sampleCreate from '@/mixins/sampleCreate';
import SubmitDialog from '../sample-component/SubmitDialog.vue';
import VerifyComponent from '../sample-component/VerifyComponent.vue';
// import { pageStatus } from '@/utils/pageInfo';

export default {
  name: 'publish-material-sample',
  components: {
    SupplierSelect,
    DictSelect,
    CustomNumInput,
    UploadFile,
    CountrySelect,
    SubmitDialog,
    VerifyComponent,
  },
  mixins: [sampleCreate],
  data() {
    return {
      formData: {
        sampleId: '',
        id: '',
        supplierCode: '',
        supplierName: '',
        productName: '',
        chineseInciName: '',
        englishInciName: '',
        cas: '',
        ec: '',
        whetherSelfProduction: '',
        whetherImport: '',
        whetherInternalSale: '',
        manufacturer: '',
        productionCountryId: [],
        rawMaterialCategory: [],
        rawMaterialEfficacy: [],
        rawMaterialFunction: [],
        recommendedAddition: '',
        maximumUsage: '',
        instructions: '',
        packageSpecification: '',
        qualityPeriod: '',
        storageConditions: '',
        havePatent: '',
        price: '',
        purchasingCycle: '',
        minNum: '',
        deliveryTime: '',
        appearance: '',
      },
      raw_material_category: [],
      raw_material_efficacy: [],
      raw_material_function: [],
      storage_conditions: [],
      rules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ],
        chineseInciName: [
          { required: true, message: '请输入中文INCI名称', trigger: 'blur' },
        ],
        englishInciName: [
          { required: true, message: '请输入英文INCI名称', trigger: 'blur' },
        ],
        whetherSelfProduction: [
          { required: true, message: '请选择是否为自己生产', trigger: 'change' },
        ],
        whetherImport: [
          { required: true, message: '请选择是否进口', trigger: 'change' },
        ],
        whetherInternalSale: [
          {
            required: true,
            message: '请选择是否国内有售卖',
            trigger: 'change',
          },
        ],
        rawMaterialCategory: [
          { required: true, message: '请选择原料分类', trigger: 'change' },
        ],
        rawMaterialEfficacy: [
          { required: true, message: '请选择原料功效', trigger: 'change' },
        ],
        rawMaterialFunction: [
          { required: true, message: '请选择原料功能', trigger: 'change' },
        ],
        recommendedAddition: [
          { required: true, message: '请输入建议添加量', trigger: 'blur' },
        ],
        instructions: [
          { required: true, message: '请输入使用说明', trigger: 'blur' },
        ],
        packageSpecification: [
          { required: true, message: '请输入包装规格', trigger: 'blur' },
        ],
        qualityPeriod: [
          { required: true, message: '请输入保质期', trigger: 'blur' },
        ],
        storageConditions: [
          { required: true, message: '请选择储存条件', trigger: 'change' },
        ],
        havePatent: [
          { required: true, message: '请选择是否有专利', trigger: 'change' },
        ],
        price: [
          { required: true, message: '请输入预估含税单价', trigger: 'blur' },
        ],
        purchasingCycle: [
          { required: true, message: '请输入采购周期', trigger: 'blur' },
        ],
        minNum: [
          {
            required: true,
            message: '请输入正式订单的最低起订量',
            trigger: 'blur',
          },
        ],
        appearance: [
          { required: true, message: '请输入外观形态', trigger: 'blur' },
        ],
        deliveryTime: [
          { required: true, message: '请输入样品的发货时间', trigger: 'blur' },
        ],
      },
      saveLoading: false,
      uploadBtns: [
        { name: 'MSDS文件', multiple: false },
        { name: 'TDS文件', multiple: false },
        { name: '有机认证文件', multiple: false },
        { name: 'PDS文件', multiple: false },
        { name: 'COA文件', multiple: false },
        { name: '市场宣称资料文件', multiple: false },
        { name: '风险物质检测报告单文件', multiple: false },
        { name: '功效验证资料文件', multiple: false },
        { name: '组分含量以及产地来源文件', multiple: false },
      ],
      submitLoading: false,
      maxlength: 30,
      status: 'add',
      statusName: '新增',
      formDisabled: false,
      dialogVisible: false,
      row: { id: '' },
      id: '',
      fileType: [
        'MSDS',
        'TDS',
        'ORGANIC_CERTIFICATION',
        'PDS',
        'COA',
        'MARKET_CLAIM_INFORMATION',
        'RISK_SUBSTANCE_TEST_REPORT',
        'EFFICACY_VERIFICATION_DATA',
        'PLACE_OF_PRODUCTION',
      ],
      uploadLoading: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.checkQueryParams(vm);
    });
  },
  mounted() {
    const { code, name } = this.$store.getters.userSupplier;
    if (code) {
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    }
    const {
      raw_material_category,
      raw_material_efficacy,
      raw_material_function,
      storage_conditions,
    } = this.$store.getters.allDictListData.data;
    this.raw_material_category = raw_material_category;
    this.raw_material_efficacy = raw_material_efficacy;
    this.raw_material_function = raw_material_function;
    this.storage_conditions = storage_conditions;
  },
  methods: {
    getDetail() {
      this.$http.sampleManage
        .getRawMaterial(this.id)
        .then(result => {
          for (let i in this.formData) {
            this.formData[i] = result.data[i];
          }
          this.formData.sampleId = this.row.id;
          this.formData.id = this.row.productId;
          this.formData.rawMaterialCategory = this.changeLabelToValue(
            result.data.rawMaterialCategory,
            this.raw_material_category,
          );
          this.formData.rawMaterialEfficacy = this.changeLabelToValue(
            result.data.rawMaterialEfficacy,
            this.raw_material_efficacy,
          );
          this.formData.rawMaterialFunction = this.changeLabelToValue(
            result.data.rawMaterialFunction,
            this.raw_material_function,
          );
          // 附件
          this.$refs.uploadRef.map((item, index) => {
            const type = this.fileType[index];
            item.fileList = result.data.sampleAttachmentVOs
              .filter(item => item.type === type)
              .map(item => {
                return {
                  fileName: item.name,
                  fileUrl: item.url,
                };
              });
          });

          let file = result.data.sampleAttachmentVOs.filter(
            item => item.type === 'MANUFACTURER_INTRODUCTION',
          );

          this.$refs.uploadMultipleRef.fileList = file.map(item => {
            return {
              fileName: item.name,
              fileUrl: item.url,
            };
          });
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    checkParams() {
      let state = true;
      return state;
    },
    changeValueToLabel(arr, data) {
      let list = arr.reduce((prev, cur) => {
        prev.push(data.find(item => item.value === cur).label);
        return prev;
      }, []);
      return list.join();
    },
    changeLabelToValue(str, data) {
      if (!str) return [];
      let list = str.split(/,|，/).reduce((prev, cur) => {
        prev.push(data.find(item => item.label === cur).value);
        return prev;
      }, []);
      return list;
    },
    saveBtn(val) {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          if (this.checkParams()) {
            let file1 = this.$refs.uploadRef.reduce((prev, cur, index) => {
              const file = cur.fileList;
              if (file.length > 0) {
                const fileName = file[0].fileName.substring(
                  file[0].fileName.lastIndexOf('.'),
                );
                prev.push({
                  name: this.uploadBtns[index].name + fileName,
                  sampleId: ['add', 'copy'].includes(this.status) ? '' : this.formData.sampleId,
                  type: this.fileType[index],
                  url: file[0].fileUrl,
                });
              }
              return prev;
            }, []);
            if (!file1.find(item => item.type === 'MSDS')) {
              this.$message.error('MSDS文件不能为空');
              return false;
            }
            if (!file1.find(item => item.type === 'TDS')) {
              this.$message.error('TDS文件不能为空');
              return false;
            }

            let params = { ...this.formData };
            // 删除小数末尾的小数点
            this.deleteLastDot(params, ['maximumUsage', 'packageSpecification', 'price', 'minNum']);
            params.id = this.id;

            const $url = ['add', 'copy'].includes(this.status) ? 'createRawMaterial' : 'updateRawMaterial';
            const AttachmentCmdList = ['add', 'copy'].includes(this.status) ? 'createSampleAttachmentCmdList' : 'updateSampleAttachmentCmdList';
            if(['add', 'copy'].includes(this.status)) {
              delete params.id;
              delete params.sampleId;
            }

            params[AttachmentCmdList] = file1;
            params.rawMaterialCategory = this.changeValueToLabel(
              params.rawMaterialCategory,
              this.raw_material_category,
            );
            params.rawMaterialEfficacy = this.changeValueToLabel(
              params.rawMaterialEfficacy,
              this.raw_material_efficacy,
            );
            params.rawMaterialFunction = this.changeValueToLabel(
              params.rawMaterialFunction,
              this.raw_material_function,
            );
            
            if (this.$refs.uploadMultipleRef.fileList) {
              let file2 = this.$refs.uploadMultipleRef.fileList.map(item => {
                return {
                  name: item.fileName,
                  sampleId: ['add', 'copy'].includes(this.status) ? '' : this.formData.sampleId,
                  type: 'MANUFACTURER_INTRODUCTION',
                  url: item.fileUrl,
                };
              });
              params[AttachmentCmdList] = [...file1, ...file2];
            }

            try {
              const msg = await this.saveParams($url, params);
              // 提交
              if (val === 'submit') {
                this.$http.sampleManage
                  .batchSubmitSample([this.row.id])
                  .then(result => {
                    if (result.data.failNum > 0) {
                      this.$message.error(
                        result.data.failResultList[0].code +
                          result.data.failResultList[0].msg,
                      );
                    } else {
                      this.dialogVisible = true;
                    }
                  })
                  .catch(err => {
                    this.$message.error(err.msg);
                  })
                  .finally(() => {
                    this.saveLoading = false;
                  });
              } else {
                if (['add', 'copy', 'update'].includes(this.status)) {
                  this.$message.success(msg);
                  this.toSamplePage('submitSuccessToHistoryTab1');
                } else if (this.status === 'verify') {
                  // 审核
                  const params = {
                    ...this.$refs.verifyComponent.verifyFormData,
                  };
                  params.sampleId = this.row.id;
                  this.saveLoading = true;
                  this.$http.sampleManage
                    .createSampleCheck(params)
                    .then(result => {
                      this.$message.success(result.msg);
                      this.toSamplePage(
                        'toListTab1',
                        'sample-manage/verify-sample',
                        '审核样品',
                      );
                    })
                    .catch(err => {
                      this.$message.error(err.msg);
                    })
                    .finally(() => {
                      this.saveLoading = false;
                    });
                }
              }
            } catch (err) {
              this.$message.error(err);
            }
          }
        } else {
          this.$message.error('必填项不能为空，请认真检查哦！');
          this.pageScrollToTop();
          return false;
        }
      });
    },
    whetherImportChange(val) {
      this.formData.whetherImport = val;
      this.formData.productionCountryId = '';
    },
    rawMaterialCategoryChange(val) {
      if (!val.includes('FUNCTIONAL_RAW_MATERIALS')) {
        this.formData.rawMaterialEfficacy = [];
      }
      if (!val.includes('BASIC_RAW_MATERIALS')) {
        this.formData.rawMaterialFunction = [];
      }
    },
    maximumUsageChange(val) {
      let num = val > 100 ? 100 : val;
      this.$refs.customNumInput.selectValue = num;
      this.formData.maximumUsage = num;
    },
    // 保存接口
    saveParams($url, params) {
      return new Promise((resolve, reject) => {
        this.saveLoading = true;
        this.$http.sampleManage[$url](params)
          .then(result => {
            // code=-1，错误提示
            if(result.data.code && result.data.code == -1) {
              reject(result.data.msg);
              return;
            }
            if (['add', 'copy'].includes(this.status)) {
              this.row.id = result.data;
            }
            resolve(result.msg);
          })
          .catch(err => {
            reject(err.msg);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      });
    },
    resetForm() {
      this.$refs.formData.resetFields();
      this.status = 'add';
      this.statusName = '新增';
      this.row = { id: '' };
      this.$refs.uploadRef.map(item => {
        item.fileList = [];
      });
      this.formData.rawMaterialCategory = [];
      this.formData.rawMaterialEfficacy = [];
      this.formData.rawMaterialFunction = [];
      this.$refs.uploadMultipleRef.fileList = [];
      const { code, name } = this.$store.getters.userSupplier;
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
      setTimeout(() => {
        this.$refs.formData.clearValidate();
      }, 500);
    },
    supplierChange(val, name) {
      this.formData.supplierCode = val;
      this.formData.supplierName = name;
    },
  },
};
</script>

<style lang="less" scope>
.fujian-row {
  position: relative;
  width: 680px;
  height: 135px;
  & > div {
    margin: 0 10px 15px 0;
    width: 210px;
  }
  .el-button--mini {
    width: 210px;
  }
  &::after {
    position: absolute;
    left: -130px;
    top: 30px;
    content: '（支持DOC、DOCX、PDF、XLS、XLSX、PPT、PPTX、JPG、PNG、JPEG格式文件）';
    width: 130px;
    font-size: 12px;
    line-height: 16px;
  }
}
.fujian-row2 {
  & > div {
    margin: 0 10px 15px 0;
    width: 210px;
  }
  .el-button--mini {
    width: 210px;
  }
}
.cml-input-maxlength .el-form-item .maximumUsage {
  .el-input--mini,
  .el-input__inner {
    width: 80px !important;
    margin: 0 5px 0 0;
  }
}
</style>
